var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 69,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 287,
    width: 57,
    height: 69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 542925,
    height: 657225
  })), /*#__PURE__*/React.createElement("image", {
    width: 94,
    height: 94,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115549 71147.1 658292 71147.1 658292 728372 115549 728372Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-274 -287)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000104987 0 0 0.000104987 274 287)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.00034 0 0 1 -115588 -71147.1)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(8472.9 8472.9)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co-2.0c693323edb5b639207e499cbc3e59cb.svg";
export { ForwardRef as ReactComponent };